import { getMailboxKeyForMailboxInfo, type MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags/lib/utils/isFeatureEnabled";
import { getItem, setItem } from "owa-local-storage/lib/localStorageAdapter";
import type { LocalStorageKeys } from "owa-local-storage";
import { PinnedGroupHeaderId, TimeHeaderId, type GroupHeaderId } from "../type/GroupHeaderId";

const LOCAL_STORAGE_KEY_PREFIX = "pinned-collapsed-state";
const PINNED_COLLAPSE_STATE_FLIGHT = "tri-pinned-collapse-state";

function getStorageKey(mailboxInfo: MailboxInfo): LocalStorageKeys {
    return `${LOCAL_STORAGE_KEY_PREFIX}_${getMailboxKeyForMailboxInfo(mailboxInfo)}`;
}

export function isPinnedGroupHeader(headerId: GroupHeaderId | undefined): boolean {
    // Both ids render the "Pinned" header: PinnedGroupHeaderId is produced when the table is
    // sorted by renew time, TimeHeaderId when the pinned item falls into the sentinel time range.
    return headerId === PinnedGroupHeaderId.Pinned || headerId === TimeHeaderId.Pinned;
}

export function getPinnedGroupHeaderCollapsedState(mailboxInfo: MailboxInfo): boolean {
    if (!isGlobalFeatureEnabled(PINNED_COLLAPSE_STATE_FLIGHT)) {
        return false;
    }
    
    try {
        return getItem(self, getStorageKey(mailboxInfo)) === "true";
    }
    catch {
        return false;
    }
}

export function setPinnedGroupHeaderCollapsedState(mailboxInfo: MailboxInfo, isCollapsed: boolean): void {
    if (!isGlobalFeatureEnabled(PINNED_COLLAPSE_STATE_FLIGHT)) {
        return;
    }
    
    try {
        setItem(self, getStorageKey(mailboxInfo), isCollapsed.toString());
    }
    catch {
        // Keep the in-memory state when local storage is unavailable.
    }
}
